import type { BackendHttpDeps } from '../http/backendHttpDeps'
import { authedBackendFetch } from '../http/backendHttpDeps'
import type { GenerationCostEstimate, GenerationCostEstimateRequest } from './CreditsApi'
import { MockCreditsApi } from './MockCreditsApi'

export class HttpCreditsApi extends MockCreditsApi {
  private readonly appId: string
  private readonly deps: BackendHttpDeps

  constructor(appId: string, deps: BackendHttpDeps) {
    super()
    this.appId = appId
    this.deps = deps
  }

  override async estimateGenerationCost(
    request: GenerationCostEstimateRequest,
  ): Promise<GenerationCostEstimate> {
    const response = await authedBackendFetch(
      this.deps,
      'POST',
      '/v1/credits/estimate',
      { ...request, gameId: this.appId },
    )
    if (!response.ok) {
      const body = await response.text()
      throw new Error(body || `Credit estimate failed (${response.status})`)
    }
    return response.json() as Promise<GenerationCostEstimate>
  }
}
